// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_1tW-CkK","small":"_1LoqFtw"};